(function() {
  var AppRouter, consultaDesdobramento, contarDesdobramento, desdobraEscolha, getArray, getEsquemaEscolhido, getEsquemaEscolhidoLoteca, listaDesdobramentos, log, scrollTo,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  $('table#table_loto_desdobramento tbody tr').live("hover", function(e) {
    return $(this).toggleClass('odd');
  });

  $("button#btn_termos_uso").live("click", function(e) {
    $("#myModal #modal-message").html($("div#termoDeUso").html());
    $("#myModal #modal-title").html("Termos e condições de uso");
    return $('#myModal').modal('show');
  });

  $("button#ajuda_como_fazer").live("click", function(e) {
    return $('#modalAjuda').modal('show');
  });

  $("ul#grupo-10-dezenas li").live("click", function(e) {
    if ($("button#desdobrar").length === 0) {
      return;
    }
    if ($("span#qtd_selecionada_fixo").length === 0) {
      $(this).toggleClass('variavel');
    } else {
      if ($(this).hasClass('fixo')) {
        $(this).removeClass('fixo');
      } else if ($(this).hasClass('variavel')) {
        $(this).addClass('fixo').removeClass('variavel');
      } else {
        $(this).addClass('variavel');
      }
    }
    $("span#qtd_selecionada_variavel").text($("ul#grupo-10-dezenas li.variavel").length);
    if ($("span#qtd_selecionada_fixo").length > 0) {
      return $("span#qtd_selecionada_fixo").text($("ul#grupo-10-dezenas li.fixo").length);
    }
  });

  getEsquemaEscolhido = function() {
    var selected;
    selected = [];
    $('ul#grupo-10-dezenas .fixo').each(function(i, el) {
      return selected.push($(el).text() + 'f');
    });
    $('ul#grupo-10-dezenas .variavel').each(function(i, el) {
      return selected.push($(el).text());
    });
    return selected.join(',');
  };

  $("table#table_loteca tr td:not(.ordem)").live("click", function(e) {
    var nTdSelected, td, tds, tr;
    if ($("button#desdobrarLoteca").length === 0) {
      return;
    }
    td = $(this);
    tr = td.parent();
    tds = tr.find('td:not(.ordem)');
    td.toggleClass('selected');
    nTdSelected = tr.find('.selected').length;
    if (nTdSelected > 0) {
      if (nTdSelected === 1) {
        tr.find('td.selected').addClass('simples').removeClass('duplo').removeClass('triplo');
      } else if (nTdSelected === 2) {
        tr.find('td.selected').addClass('duplo').removeClass('simples').removeClass('triplo');
      } else if (nTdSelected === 3) {
        tr.find('td.selected').addClass('triplo').removeClass('duplo').removeClass('simples');
      }
    } else {
      tds.removeClass();
    }
    return contarDesdobramento();
  });

  contarDesdobramento = function() {
    var duplos, simples, triplos;
    simples = $("table#table_loteca tr .selected.simples").length;
    duplos = parseInt($("table#table_loteca tr .selected.duplo").length / 2);
    triplos = parseInt($("table#table_loteca tr .selected.triplo").length / 3);
    $('#qtd_selecionada_simples').html(simples);
    $('#qtd_selecionada_duplos').html(duplos);
    $('#qtd_selecionada_triplos').html(triplos);
    return true;
  };

  $('#limpar_selecionada').live("click", function(e) {
    e.preventDefault();
    return $('table#table_loteca td:not(.ordem)').removeClass();
  });

  getEsquemaEscolhidoLoteca = function() {
    var selected;
    selected = [];
    $('table#table_loteca .selected').each(function(i, el) {
      return selected.push($(el).attr('data-item'));
    });
    return selected.join(',');
  };

  getArray = function(min, max) {
    var arrayNumeros;
    arrayNumeros = [];
    while (max >= min) {
      arrayNumeros.push(max--);
    }
    return arrayNumeros;
  };

  Array.prototype.shuffle = function() {
    var i, j, temp, _results;
    i = this.length;
    if (i === 0) {
      return;
    }
    _results = [];
    while (--i) {
      j = Math.floor(Math.random() * (i + 1));
      temp = this[i];
      this[i] = this[j];
      _results.push(this[j] = temp);
    }
    return _results;
  };

  $("button#limpar_selecionada").live("click", function(e) {
    $("ul#grupo-10-dezenas li").removeClass('variavel').removeClass('fixo');
    $("span#qtd_selecionada_variavel").text($("ul#grupo-10-dezenas li.variavel").length);
    if ($("span#qtd_selecionada_fixo").length > 0) {
      return $("span#qtd_selecionada_fixo").text($("ul#grupo-10-dezenas li.fixo").length);
    }
  });

  $("button#desdobrar").live("click", function(e) {
    if ($("#inicio_concurso").val() === "0") {
      return $('#modalQuerConferencia').modal('show');
    } else {
      return desdobraEscolha();
    }
  });

  $("button#desdobrarModal").live("click", function(e) {
    return desdobraEscolha();
  });

  desdobraEscolha = function() {
    return jsRoutes.controllers.Desdobramentos.desdobra($("button#desdobrar").attr("data-desdobramento-id")).ajax({
      type: "POST",
      context: this,
      cache: false,
      data: {
        esquemaUsuario: getEsquemaEscolhido(),
        inicio_concurso: $("#inicio_concurso").val(),
        qtd_concurso: $("#qtd_concurso").val(),
        desdobramentoLead: $('#form-conferencia #email').length > 0 ? 1 : 0,
        email: $('#form-conferencia #email').length > 0 ? $('#form-conferencia #email').val() : null
      },
      success: function(data) {
        $("#matrizResultado").html($(data));
        return $('html, body').animate({
          scrollTop: $("#matrizResultado").offset().top
        }, 600);
      },
      error: function(err) {
        if (err.status >= 500) {
          $("#myModal #modal-message").html("<p>Desculpe, algum problema ocorreu. Por favor, tente novamente.</p>");
        } else {
          $("#myModal #modal-message").html("<p>" + err.responseText + "</p>");
        }
        $("#myModal #modal-title").html("Aviso");
        return $('#myModal').modal('show');
      }
    });
  };

  consultaDesdobramento = function(pedido) {
    jsRoutes.controllers.Desdobramentos.consulta(pedido).ajax({
      context: this,
      cache: false,
      success: function(data) {
        return $("#main").html($(data));
      },
      error: function(err) {
        if (err.status >= 500) {
          $("#myModal #modal-message").html("<p>Desculpe, algum problema ocorreu. Por favor, tente novamente.</p>");
        } else {
          $("#myModal #modal-message").html("<p>" + err.responseText + "</p>");
        }
        $("#myModal #modal-title").html("Aviso");
        return $('#myModal').modal('show');
      }
    });
    return true;
  };

  $("a#enviaEmailParaConfirmacao").live("click", function(e) {
    jsRoutes.controllers.Usuarios.enviaEmailParaConfirmacao().ajax({
      context: this,
      cache: false,
      success: function(data, textStatus, req) {
        return $("#myModal #modal-message").html("<p>" + req.responseText + "</p>");
      },
      error: function(err) {
        if (err.status >= 500) {
          return $("#myModal #modal-message").html("<p>Desculpe, algum problema ocorreu. Por favor, tente novamente.</p>");
        } else {
          return $("#myModal #modal-message").html("<p>" + err.responseText + "</p>");
        }
      }
    });
    $("#myModal #modal-title").html("Aviso");
    $('#myModal').modal('show');
    return true;
  });

  $("button#desdobrarLoteca").live("click", function(e) {
    return jsRoutes.controllers.Desdobramentos.desdobraLoteca($(this).attr("data-desdobramento-id")).ajax({
      type: "POST",
      cache: false,
      context: this,
      data: {
        esquemaUsuario: getEsquemaEscolhidoLoteca(),
        inicio_concurso: $("#inicio_concurso").val(),
        desdobramentoLead: $('#form-conferencia #email').length > 0 ? 1 : 0,
        email: $('#form-conferencia #email').length > 0 ? $('#form-conferencia #email').val() : null
      },
      success: function(data) {
        $("#matrizResultado").html($(data));
        return $('html, body').animate({
          scrollTop: $("#matrizResultado").offset().top
        }, 600);
      },
      error: function(err) {
        if (err.status >= 500) {
          $("#myModal #modal-message").html("<p>Desculpe, algum problema ocorreu. Por favor, tente novamente.</p>");
        } else {
          $("#myModal #modal-message").html("<p>" + err.responseText + "</p>");
        }
        $("#myModal #modal-title").html("Aviso");
        return $('#myModal').modal('show');
      }
    });
  });

  $("button#completar").live("click", function(e) {
    var arrayAleatorio, cont, qtd_numeros, qtd_numeros_fixos, qtd_numeros_modalidade;
    qtd_numeros = $("button#completar").attr("data-desdobramento-qtd-numeros");
    qtd_numeros_fixos = $("button#completar").attr("data-desdobramento-qtd-numeros-fixos");
    qtd_numeros_modalidade = $("button#completar").attr("data-desdobramento-qtd-numeros-modalidade");
    arrayAleatorio = getArray(1, qtd_numeros_modalidade);
    arrayAleatorio.shuffle();
    cont = 0;
    while ($("ul#grupo-10-dezenas li.variavel").length + $("ul#grupo-10-dezenas li.fixo").length < qtd_numeros) {
      $("ul#grupo-10-dezenas li:not(.variavel, .fixo)#num_" + arrayAleatorio[cont++]).click();
    }
    cont = 0;
    while ($("ul#grupo-10-dezenas li.fixo").length < qtd_numeros_fixos) {
      $("ul#grupo-10-dezenas li:(variavel)#num_" + arrayAleatorio[cont++]).click();
    }
    return true;
  });

  listaDesdobramentos = function(modalidade) {
    jsRoutes.controllers.Application.lista(modalidade).ajax({
      context: this,
      cache: false,
      success: function(data) {
        return $("#main").html($(data));
      },
      error: function(err) {
        if (err.status >= 500) {
          $("#myModal #modal-message").html("<p>Desculpe, algum problema ocorreu. Por favor, tente novamente.</p>");
        } else {
          $("#myModal #modal-message").html("<p>" + err.responseText + "</p>");
        }
        $("#myModal #modal-title").html("Aviso");
        return $('#myModal').modal('show');
      }
    });
    return true;
  };

  $("a#conferir").live("click", function(e) {
    jsRoutes.controllers.Concursos.conferePedido($(this).attr("data-pedido-id")).ajax({
      context: this,
      cache: false,
      success: function(data) {
        $('#myModal #modal-message').html($(data));
        $('#myModal #modal-title').html("Conferência de sorteios");
        return $('#myModal').modal('show');
      },
      error: function(err) {
        if (err.status >= 500) {
          $('#myModal #modal-message').html("<p>Desculpe, algum problema ocorreu. Por favor, tente novamente.</p>");
        } else {
          $('#myModal #modal-message').html("<p>" + err.responseText + "</p>");
        }
        $('#myModal #modal-title').html("Aviso");
        return $('#myModal').modal('show');
      }
    });
    return true;
  });

  $("a#consultaPremiacao").live("click", function(e) {
    jsRoutes.controllers.Premiacoes.consultaPremiacao($(this).attr("data-pedido-id"), $(this).attr("data-concurso-id")).ajax({
      context: this,
      cache: false,
      success: function(data) {
        $('#myModal #modal-message').html($(data));
        $('#myModal #modal-title').html("Premiação");
        return $('#myModal').modal('show');
      },
      error: function(err) {
        if (err.status >= 500) {
          $('#myModal #modal-message').html("<p>Desculpe, algum problema ocorreu. Por favor, tente novamente.</p>");
        } else {
          $('#myModal #modal-message').html("<p>" + err.responseText + "</p>");
        }
        $('#myModal #modal-title').html("Aviso");
        return $('#myModal').modal('show');
      }
    });
    return true;
  });

  $("a#gerarPDF").live("click", function(e) {
    $(this).attr('href', $(this).attr('data-url') + '?x=' + $("input#x").val() + '&y=' + $("input#y").val());
    return true;
  });

  scrollTo = function(div) {
    $('html, body').animate({
      scrollTop: $(div).offset().top
    }, 600);
    return true;
  };

  $("button.planosHotSite").live("click", function(e) {
    return $('html, body').animate({
      scrollTop: $("#planos").offset().top
    }, 600);
  });

  log = function() {
    var args;
    args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
    if (console.log != null) {
      return console.log.apply(console, args);
    }
  };

  AppRouter = (function(_super) {
    __extends(AppRouter, _super);

    function AppRouter() {
      return AppRouter.__super__.constructor.apply(this, arguments);
    }

    AppRouter.prototype.initialize = function() {
      return {
        el: $("#main")
      };
    };

    AppRouter.prototype.routes = {
      "/": "index",
      "/desdobramento/:desdobramento": "desdobramentos",
      "/desdobramento/consulta/:pedido": "consulta",
      "/desdobramento/lista/:modalidade": "lista",
      "/premiacao/:pagina/:saldo/:bilhete": "premiacao"
    };

    AppRouter.prototype.index = function() {
      return $("#main").load("/ #main");
    };

    AppRouter.prototype.desdobramentos = function(desdobramento) {
      return $("#main").load("/desdobramento/" + desdobramento);
    };

    AppRouter.prototype.premiacao = function(pagina, saldo, bilhete) {
      return $("#divPremiacao").load("/premiacao?pagina=" + pagina + "&saldoPositivo=" + saldo + "&bilhete=" + bilhete);
    };

    AppRouter.prototype.consulta = function(pedido) {
      return consultaDesdobramento(pedido);
    };

    AppRouter.prototype.lista = function(modalidade) {
      return listaDesdobramentos(modalidade);
    };

    return AppRouter;

  })(Backbone.Router);

  $(function() {
    var app;
    app = new AppRouter();
    Backbone.history.start({
      pushHistory: true
    });
    if ($("div#modalDesconto").length > 0) {
      return $('#modalDesconto').modal('show');
    } else if ($("input#mostrarModalAjuda").length > 0) {
      return $("button#ajuda_como_fazer").click();
    }
  });

}).call(this);

//# sourceMappingURL=main.js.map
;
define("main", function(){});

